import { jsxs as u, jsx as n } from "react/jsx-runtime";
import { ServicingRate as O } from "@strata/react-servicing-rate";
import { StatusIcon as t } from "@strata/react-status-icons";
import c from "classnames";
import "./main.scss";
const s = {
  WINNING: "winning",
  LOSING: "losing",
  NO_BID: "no-bid",
  LOST: "lost",
  WON: "won"
}, l = {
  [s.WINNING]: "You have the current winning bid.",
  [s.LOSING]: "You have been outbid.",
  [s.WON]: "Congratulations! You won this referral.",
  [s.LOST]: "Sorry, you lost this referral."
}, I = {
  [s.WINNING]: t.Statuses.GOOD,
  [s.LOSING]: t.Statuses.CAUTION,
  [s.WON]: t.Statuses.GOOD,
  [s.LOST]: t.Statuses.CAUTION
}, m = ({
  bidAmount: r = void 0,
  referentPriceType: i = void 0,
  bidState: o = s.NO_BID,
  isPending: N = !1
}) => {
  const a = !Number.isNaN(r), e = o !== s.NO_BID && a;
  return /* @__PURE__ */ u(
    "div",
    {
      className: c("sds_current-bid", {
        [`sds_current-bid--${o}`]: e
      }),
      children: [
        /* @__PURE__ */ n(
          O,
          {
            servicingRate: r,
            referentPriceType: i,
            isPending: N
          }
        ),
        e && /* @__PURE__ */ n(
          t,
          {
            className: "margin__left--x-small",
            status: I[o],
            tooltipText: l[o]
          }
        )
      ]
    }
  );
};
m.states = s;
export {
  m as CurrentBid
};
//# sourceMappingURL=index.js.map
